import React from "react";

import {AutoComplete} from "antd";

import {rankSortedSuggestions, sortOptionsNaturally} from "./suggestions";

const toText = value => (value === undefined || value === null ? "" : String(value));

const SuggestAutoComplete = ({options, value, onChange, onSearch, ...rest}) => {
	const [typedQuery, setTypedQuery] = React.useState("");
	const query = typeof value === "string" || typeof value === "number" ? toText(value) : typedQuery;
	const sortedOptions = React.useMemo(() => sortOptionsNaturally(options), [options]);
	const rankedOptions = React.useMemo(() => rankSortedSuggestions(sortedOptions, query), [sortedOptions, query]);

	const handleChange = (nextValue, option) => {
		setTypedQuery(toText(nextValue));
		if (onChange) onChange(nextValue, option);
	};

	const handleSearch = searchText => {
		setTypedQuery(toText(searchText));
		if (onSearch) onSearch(searchText);
	};

	return (
		<AutoComplete
			{...rest}
			value={value}
			options={rankedOptions}
			filterOption={false}
			onChange={handleChange}
			onSearch={handleSearch}
		/>
	);
};

export default SuggestAutoComplete;
